import { useState, useEffect } from 'react';
import { Box, FormControl, makeStyles, Select, MenuItem, TextField, InputAdornment, Typography } from '@material-ui/core';
import { OIDValid } from '../helpers';

const SNMP_VERSION_OPTIONS = [
    { key: '0', name: 'SNMP V1' },
    { key: '1', name: 'SNMP V2c' }
];

const SNMPS_OPTION_TYPE = [
    { key: '0', name: 'INTEGER' },
    { key: '1', name: 'GAUGE32' },
    { key: '2', name: 'OPAQUE FLOAT' },
    { key: '3', name: 'COUNTER32' }
];

const useStyles = makeStyles(() => ({
    devicesLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '0.75rem',
    },
    input: {
        '& .MuiInputBase-input': {
            '&::-webkit-inner-spin-button': {
                webkitAppearance: "none",
                mozAppearance: "none",
                appearance: "none",
                margin: 0
            },
        },
    },
}));

const SnmpdAndSnmptFilterOptions = ({ varState, setVarState, blockNodeSettings, setDisabledButtonSave }) => {
    const [stateForm, setStateForm] = useState({});
    const [oidValid, setOidValid] = useState(true);
    const classes = useStyles();

    useEffect(() => {
        if (varState?.a) {
            setStateForm(varState.a);
            let isValid = false
            if (varState?.type === 'SNMPD') {
                isValid = OIDValid(varState.a?.o) && OIDValid(varState.a?.do);
            }
            //si es SNMPT
            else {
                if (varState.a?.o && varState.a?.v === '1') {
                    isValid = OIDValid(varState.a?.o)
                }
            }
            // setOidValid(isValid);
            setDisabledButtonSave(isValid);
        }
    }, []);

    useEffect(() => {
        setVarState({ ...varState, a: stateForm });
    }, [stateForm]);


    useEffect(() => {
        let isValid = false
        if (varState?.type === 'SNMPD') {
            if (stateForm?.v === '1') {
                isValid = OIDValid(stateForm?.o ?? '') || OIDValid(stateForm?.do ?? '');
            }
            else {
                isValid = OIDValid(stateForm?.s ?? '') || OIDValid(stateForm?.do ?? '');
            }
        }
        else {
            if (stateForm?.v === '1') {
                isValid = OIDValid(stateForm?.o ?? '');
            }
            else {
                isValid = OIDValid(stateForm?.s ?? '');
            }
        }
        setOidValid(!isValid);
        setDisabledButtonSave(isValid);
    }, [stateForm]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStateForm(prev => {
            let newState = {
                ...prev,
                [name]: value
            };
            if (name === 'v') {
                if (value === '0') {
                    delete newState.o; // Eliminar 'o' si es SNMP v1
                } else if (value === '1') {
                    delete newState.s; // Eliminar 's' si es SNMP v2c
                }
            }
            return newState;
        });
    };

    const renderField = (element) => {
        const { key, name, type, default: defaultValue } = element;
        const isHidden = (
            (key === 's' && stateForm?.v !== '0') ||
            (key === 'o' && stateForm?.v !== '1')
        );
        if (isHidden) return null;
        const isSelect = ['v', 'dt'].includes(key);
        const options = key === 'v' ? SNMP_VERSION_OPTIONS : SNMPS_OPTION_TYPE;
        const showOidPrefix = ['o', 'do'].includes(key);

        return (
            <Box key={key} mt={2}>
                <Box display="flex" alignItems="center" flexWrap="wrap">
                    <Box className={classes.devicesLabel}>{name}</Box>
                </Box>
                <Box width="100%">
                    {isSelect ? (
                        <FormControl fullWidth>
                            <Select
                                name={key}
                                value={stateForm?.[key] ?? defaultValue}
                                onChange={handleChange}
                            >
                                {options.map(opt => (
                                    <MenuItem key={opt.key} value={opt.key}>{opt.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <TextField
                            fullWidth
                            name={key}
                            // label={name}
                            size="small"
                            variant="outlined"
                            type={type === 'uint' ? 'number' : 'text'}
                            value={stateForm?.[key] ?? ''}
                            onChange={handleChange}
                            className={classes.input}
                            InputProps={{
                                startAdornment: showOidPrefix && (
                                    <InputAdornment position="start" style={{ marginRight: 0 }}>
                                        <Typography component="span" style={{ whiteSpace: 'nowrap' }}>1.3.6.1.4.1.51701.0.</Typography>
                                    </InputAdornment>
                                )
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    )}
                </Box>
            </Box>
        );
    };

    return (
        <Box>
            {(blockNodeSettings?.atributes_keys || []).map(renderField)}
            {!oidValid && (
                <Box mt={1} color="red">
                    Error: valor inválido.
                </Box>
            )}
        </Box>
    );
};

export default SnmpdAndSnmptFilterOptions;




